import styled from "styled-components";

import { ProfileBillingStyledProps as Props } from "./ProfileBilling.types";
import CONSTANTS from "config/constants";

const { desktop, tablet, mobile } = CONSTANTS.BREAKPOINTS;

const ProfileBillingStyled = styled.div<Props>`
  min-width: var(--sizes-page-minWidth);
  max-width: var(--sizes-page-maxWidth);
  min-height: var(--sizes-page-minHeight);
  padding-top: ${props =>
    !props.withBottomResponsiveButtons
      ? "var(--sizes-navbar-height-mobile-without-bottom-buttons)"
      : props.withBottomSearch
      ? "var(--sizes-navbar-height-mobile)"
      : "var(--sizes-navbar-height-mobile-without-search)"};
  background-color: var(--palette-black-s0-l10);
  display: grid;
  grid-template-columns: var(--sizes-page-columns);
  grid-template-rows: 1fr;
  grid-template-areas:
    ".      main   ."
    "footer footer footer";

  @media (max-width: ${tablet}px) {
    padding-top: var(--sizes-navbar-height-mobile);
    grid-template-areas:
      "main     main   main"
      "footer footer footer";
  }

  @media (min-width: ${desktop}px) {
    padding-top: calc(var(--sizes-navbar-height));
  }

  .ProfileBilling {
    &__header {
    }

    &__go-back {
      margin-left: -1.6rem;

      .GoBack {
        &__title {
          font-weight: 600;
        }
      }
    }

    &__main {
      grid-area: main;
      display: flex;
      flex-direction: column;
    }

    &__layout {
      flex: 1;
      display: flex;
      padding-top: 8.8rem;
      padding-bottom: 3.2rem;

      @media (max-width: ${tablet}px) {
        padding-top: 0.8rem;
      }
    }

    &__container {
      padding: 0;
      flex: 1;
      padding: 0 2rem;

      @media (min-width: ${desktop}px) {
        padding: 0 8rem;
      }

      @media (max-width: ${mobile}px) {
        padding: 0 1rem;
      }
    }

    &__profile-navigation {
      width: 40rem;
      margin-left: 4rem;
      padding: 0;

      @media (max-width: ${tablet}px) {
        display: none;
      }
    }

    &__billing-data {
      flex: 1;
      padding: 2.4rem;
      background-color: var(--palette-black-s2-l17);
      border-radius: 1.6rem;
      display: flex;
      flex-direction: column;
      min-width: 37.5rem;

      @media (max-width: ${tablet}px) {
        min-width: auto;
        padding: 1.6rem;
        margin: 1.6rem 0.8rem;
      }

      &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 3.2rem;

        @media (max-width: ${tablet + 1}px) {
          margin-bottom: 1.6rem;
        }

        &__title {
          font-size: 1.6rem;
          font-weight: 400;
          color: var(--palette-white);

          @media screen and (min-width: ${desktop}px) {
            display: block;
            font-size: 2rem;
          }
        }

        .AddNewRecordButton {
          border-radius: 7.2rem;
        }
      }
    }

    &__footer {
      grid-area: footer;
    }
  }
`;

export const ModalHeaderStyled = styled.div`
  padding: 1.6rem 2.4rem;
  font-weight: 600;
  font-size: 1.6rem;
  background-color: var(--palette-black-s2-l17);
  text-align: center;
  flex: 1;

  .ModalHeaderStyled {
    &__header {
      color: var(--palette-black-s0-l10);
    }
  }
`;

export default ProfileBillingStyled;
